<div class="modal-header">
  <h3 class="text-center">Enviar mensaje</h3>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="modal-body">
  <p>
    Estás enviando un mensaje a: <strong>{{ data.ejecutivo?.nombre }}</strong>
  </p>
  <form [formGroup]="mensajeForm">
    <mat-form-field class="full-width">
      <mat-label>Escribe tu mensaje</mat-label>
      <textarea 
        placeholder="Mensaje" 
        matInput 
        formControlName="mensaje" 
        rows="4">
      </textarea>
    </mat-form-field>
  </form>
</div>

<div class="modal-footer">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button 
    mat-raised-button 
    color="primary" 
    (click)="enviarMensaje()" 
    [disabled]="mensajeForm.invalid">
    Enviar
  </button>
</div>
